<template>
  
  <div>

      <!-- <second-slot-child ref="secondSlotsChildRef"></second-slot-child>
    <script src="https://unpkg.com/axios/dist/axios.min.js"></script>

      <button id="mutateFakeBooking" @click="$refs.secondSlotsChildRef.fakeBookingMutate"></button> -->

<!-- 
    <script type="application/javascript">

     function justMakeAlertInTag(){
            
            alert(`in justMakeAlert`); 
            
            return ' no error';
    };


    </script> -->
  </div>
  

</template>

<script type="application/javascript">

    async function justCallFakeBookingMutate(slot, user, dayDate){
        
        alert(`in justCallFakeBookingMutate with: ${JSON.stringify(slot)}`);        

        return ' no error';

            try{    
                    const myData = {

                            email: user.email,

                            userId: user.id,
                    
                            userPoints: user.coins,

                            slotId: slot.id,
                    
                            points: slot.points_cost,

                            dayDate:  dayDate,

                            businessId: slot.class.business.id,

                            classId: slot.class.id
                    };

                    // alert(`successfully Sending: ${JSON.stringify(myData)}`)

                    let result = await axios({method: 'post',url: '/pnadiapi/fakeBookings/bookSession',
                        data: myData
                        });
                }catch(error){

                    alert(`error: ${error}`);
                }

        return 'no error';
      };

import Vue from 'vue';


import myQueries from '../hasura/myQueries';
import myInserts from '../hasura/myInserts';
import mySubscriptions from '../hasura/mySubscriptions';

import secondSlotsChild from '../components/SecondSlotsChild'

import moment from 'moment';

import componentsHelpers from '../classes/componentHelpers';

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


export default {

    mounted(){

        // alert(`in second slot`);

        // console.log(`in second slot`);
    },

    components:{

        secondSlotsChild
    },

    methods:{

    sendSlotPostMessage(secondSlot, isIos){


        if(this.daysCount == 1){

            this.sevenDaysSlots = [];
        }
        // alert('in  sendSlotPostMessage')


        // console.log(`slots: ${JSON.stringify(secondSlot)}`);

        this.daysCount = this.daysCount + 1;

        this.sevenDaysSlots.push(secondSlot);

        if(this.daysCount < 8){

            this.goNextOrPrevious(true);
        }else{
        
                // console.log(`in  sendSlotPostMessage with isiOS: ${isIos}`);

                // console.log(`slots: ${JSON.stringify(this.sevenDaysSlots)}`);

            if(isIos){

                // alert(`slots: ${JSON.stringify(this.sevenDaysSlots)}`);

                window.webkit.messageHandlers.secondSlot.postMessage(JSON.stringify(this.sevenDaysSlots))
            }
        }
    },

        sendBookingsPostMessage(secondBookings){

            // alert('in  sendBookingsPostMessage')

        window.webkit.messageHandlers.secondBookings.postMessage(JSON.stringify(secondBookings))
        },

        setSlots(fromSearch = false){

            // console.log(`in setSlots`);
            // console.log(`apollo slots: ${JSON.stringify(this.slot)}`)

            // console.log(` Slots count ${this.slot.length}`);
            
            const equalMethod = this.isEqualToWeeKDay;
            
            const selectionDay = this.dayOfWeekAsString(new Date(this.dayDate).getDay());

            // console.log(`selectionDay is:${selectionDay}`)

            const weekDayFilter = item => equalMethod(item, selectionDay);
            
            if(this.onlyOnline){

                const justOnlineSlots = this.slot.filter(item => item.class.is_online == true);
                
                // console.log(`justOnlineSlots: ${JSON.stringify(justOnlineSlots)}`);

                this.weekDayCategorizedSlots = justOnlineSlots.filter(weekDayFilter);
            }
            else{

                this.weekDayCategorizedSlots = this.slot.filter(weekDayFilter);
            }

            // console.log(`weekDayCategories: ${JSON.stringify(this.weekDayCategorizedSlots)}`);

            this.timedCategorizedSlots = this.weekDayCategorizedSlots.filter(item => item);

            this.sortTimes(this.timedCategorizedSlots);

            if(this.savedStartTimeAfter != '' && this.savedStartTimeBefore != ''){

                this.filterByTime(this.savedStartTimeAfter, this.savedStartTimeBefore);
            }
            else if(this.savedStartTimeAfter != ''){

                this.filterByTime(this.savedStartTimeAfter,null);
            }
            else if(this.savedStartTimeBefore != ''){

                this.filterByTime(null ,this.savedStartTimeBefore);
            }
            else{
                
                this.categorizedSlots = this.timedCategorizedSlots;
            }

                // console.log(`categorizedSlots: ${JSON.stringify(this.categorizedSlots)}`);

                // console.log(`proxy length: ${this.slotsCategoriesOptionsProxy.length}`);

                if(this.slotsCategoriesOptionsProxy.length > 0){

                    this.filterSelectionSlots();
                }

                if(this.searchInput != ''){

                    this.doSearch();
                }

                const newSlotPostObject = {

                    dayDate: this.dayDate,
                    slot: this.categorizedSlots,
                }


                if(navigator.userAgent == 'Safari/602.1 ios-pnadi'){
                    

                    this.sendSlotPostMessage(newSlotPostObject, true);
                }else{

                    this.sendSlotPostMessage(newSlotPostObject, false);
                }

                // this.setLocations();
            
            // this.$forceUpdate();
            // this.cardsViews = [];
        },

        isEqualToWeeKDay(item, weekDayName){

            const startDate = moment(item.start_date).format(moment.HTML5_FMT.DATE);

            const endDate = moment(item.end_date).format(moment.HTML5_FMT.DATE);

            const dayDate = moment(this.dayDate).format(moment.HTML5_FMT.DATE);

            if(dayDate >= startDate && dayDate <= endDate){

                if(weekDayName === 'Monday'){
                    
                    if(item.monday == true){

                        if(!this.timePassed(item))
                        {
                            return true;
                        }
                        else{
                            
                            return false;
                        }
                    }
                    else{
                        
                        return false;
                    }
                }

                if(weekDayName === 'Tuesday'){
                    
                    if(item.tuesday == true){

                        if(!this.timePassed(item))
                        {
                            return true;
                        }
                        else{
                            
                            return false;
                        }
                    }
                    else{
                        return false;
                    }
                }

                if(weekDayName === 'Wednesday'){
                    
                    if(item.wednesday == true){

                        if(!this.timePassed(item))
                        {
                            return true;
                        }
                        else{
                            
                            return false;
                        }
                    }
                    else{
                        return false;
                    }
                }

                if(weekDayName === 'Thursday'){
                    
                    if(item.thursday == true){

                        if(!this.timePassed(item))
                        {
                            return true;
                        }
                        else{
                            
                            return false;
                        }
                    }
                    else{
                        return false;
                    }
                }

                if(weekDayName === 'Friday'){
                    
                    if(item.friday == true){

                        if(!this.timePassed(item))
                        {
                            return true;
                        }
                        else{
                            
                            return false;
                        }
                    }
                    else{
                        return false;
                    }
                }

                if(weekDayName === 'Saturday'){
                    
                    if(item.saturday == true){

                        if(!this.timePassed(item))
                        {
                            return true;
                        }
                        else{
                            
                            return false;
                        }
                    }
                    else{
                        return false;
                    }
                }

                if(weekDayName === 'Sunday'){
                    
                    if(item.sunday == true){

                        if(!this.timePassed(item))
                        {
                            return true;
                        }
                        else{
                            
                            return false;
                        }
                    }
                    else{
                        return false;
                    }
                }
            }
            else{

                return false;
            }            

        },

        timePassed(slot){

            const today = moment(new Date()).format(moment.HTML5_FMT.DATE);
            
            // console.log(`today: ${today.toString()}, and dayDate: ${this.dayDate.toString()}`);
            
            if(today == this.dayDate)
            {

                let startTime = moment(new Date(`1970/01/01 ${slot.start_time}`)).format('hh:mm A')

                startTime = moment(startTime, 'hh:mm a');

                const timeNow = moment(new Date());


                if(moment(timeNow).isSameOrAfter(startTime))
                {

                    return true;
                }
                else{
                

                    return false;
                }
            }
            else{

                return false;
            }
        },

        sortTimes(array) {
            
            return array.sort(function (a, b) {
                if (parseInt(a.start_time.split(":")[0]) - parseInt(b.start_time.split(":")[0]) === 0) {
                    return parseInt(a.start_time.split(":")[1]) - parseInt(b.start_time.split(":")[1]);
                } else {
                    return parseInt(a.start_time.split(":")[0]) - parseInt(b.start_time.split(":")[0]);
                }
            })
        },

        dayOfWeekAsString(dayIndex) {
            
            return [this.$t('slot.sunday'), this.$t('slot.monday'), this.$t('slot.tuesday'),this.$t('slot.wednesday'),this.$t('slot.thursday'),this.$t('slot.friday'),this.$t('slot.saturday')][dayIndex];
        },

        timePassed(slot){

            const today = moment(new Date()).format(moment.HTML5_FMT.DATE);
            
            // console.log(`today: ${today.toString()}, and dayDate: ${this.dayDate.toString()}`);
            
            if(today == this.dayDate)
            {

                let startTime = moment(new Date(`1970/01/01 ${slot.start_time}`)).format('hh:mm A')

                startTime = moment(startTime, 'hh:mm a');

                const timeNow = moment(new Date());


                if(moment(timeNow).isSameOrAfter(startTime))
                {

                    return true;
                }
                else{
                

                    return false;
                }
            }
            else{

                return false;
            }
        },

        sortTimes(array) {
            
            return array.sort(function (a, b) {
                if (parseInt(a.start_time.split(":")[0]) - parseInt(b.start_time.split(":")[0]) === 0) {
                    return parseInt(a.start_time.split(":")[1]) - parseInt(b.start_time.split(":")[1]);
                } else {
                    return parseInt(a.start_time.split(":")[0]) - parseInt(b.start_time.split(":")[0]);
                }
            })
        },

        dayOfWeekAsString(dayIndex) {
            
            return [this.$t('slot.sunday'), this.$t('slot.monday'), this.$t('slot.tuesday'),this.$t('slot.wednesday'),this.$t('slot.thursday'),this.$t('slot.friday'),this.$t('slot.saturday')][dayIndex];
        },

        filterByTime(time1, time2){

            // console.log(`time1: ${time1}, times: ${time2}`);

            const timeFilter = (item) => {
                
                const startTimeDate = new Date('1970/01/01 ' + item.start_time  + '')
                
                // console.log(`startTimeDate: ${JSON.stringify(startTimeDate)}`);
                
                if(time1 != null && time2 != null)
                {
                    const timeAfterDate = new Date('1970/01/01 ' + time1  + '');
                
                    const timeBeforeDate = new Date('1970/01/01 ' + time2  + '');

                // console.log(`timeAfterDate: ${JSON.stringify(timeAfterDate)}`);

                // console.log(`timeBeforeDate: ${JSON.stringify(timeBeforeDate)}`);

                    if(startTimeDate >= timeAfterDate && startTimeDate <= timeBeforeDate){
                        
                        // console.log(`return true for both`);

                        return true;
                    }

                    // console.log(`return false for both`);

                    return false;
                }
                else if(time1 != null){

                    const timeAfterDate = new Date('1970/01/01 ' + time1  + '');
    
                    // console.log(`timeAfterDate: ${JSON.stringify(timeAfterDate)}`);

                    if(startTimeDate >= timeAfterDate)
                    {

                        // console.log(`return true for time1`);

                        return true;
                    }

                    // console.log(`return false for time1`);
                    
                    return false;
                }

                else if(time2 != null){
                    
                    const timeBeforeDate = new Date('1970/01/01 ' + time2  + '');

                    // console.log(`timeBeforeDate: ${JSON.stringify(timeBeforeDate)}`);

                    if(startTimeDate <= timeBeforeDate)
                    {

                        // console.log(`return true for time2`);

                        return true;
                    }

                    // console.log(`return false for time2`);                    
                    return false;
                }
                else{
                    
                    // console.log(`return false for none`);                    

                    return true;
                }
            } 

            // console.log(`timedCategorizedSlots: ${JSON.stringify(this.timedCategorizedSlots)}`);

            this.categorizedSlots = this.timedCategorizedSlots.filter(timeFilter);
        },

        goNextOrPrevious(value){
            
            // console.log(`in goNextOrPrevious`);

                for(let i = 0; i < this.categorizedSlots.length; i ++)
                {

                    Vue.set(this.categorizedSlots,i, this.categorizedSlots[i]);
                }

            let dayDate = moment(this.dayDate);

            if(value){

                dayDate = moment(dayDate).add(1, 'days');
                
                this.dayDate = moment(dayDate).format(moment.HTML5_FMT.DATE);

                this.setSlots();
            }

            else{

                if(dayDate > moment()){
                    
                    dayDate = moment(dayDate).subtract(1, 'days');

                    this.dayDate = moment(dayDate).format(moment.HTML5_FMT.DATE);

                    this.setSlots();
                }
            }
        },

       changeDayDate(date) {
           
            // console.log(`date is ${JSON.stringify(date)}`);
           const todayDate = moment(todayDate).format(moment.HTML5_FMT.DATE);
            // console.log(`todayDate: ${todayDate}`);
           
           const newDate = moment(date).format(moment.HTML5_FMT.DATE);
            // console.log(`newDate: ${newDate}`);


           if(newDate < todayDate)
           {    
               
               this.dayDate = todayDate;
               
               alert(`You can't pick an old date`);
                
                this.setSlots();

               return
           }
           else{

            this.dayDate = newDate;

           this.setSlots();
           }

           if(this.minimizeAll){

                if(typeof this.$refs.slotCardChild === 'undefined'){
                    
                    // componentsHelpers.toastIt(this.$toasted, 'Something went wrong', 3, 'outline', true);

                    return;
                }
                
               for(let i = 0; i< this.$refs.slotInfoChild.length; i++)
               {
                   
                   this.$refs.slotInfoChild[i].setIsBooked(this.dayDate);
               }
           }
           else{
                
               if(typeof this.$refs.slotCardChild === 'undefined'){

                    //console.log(`I'm in`);
                   // componentsHelpers.toastIt(this.$toasted, 'Something went wrong', 3, 'outline', true);
                   return;
               }

               for(let i = 0; i< this.$refs.slotCardChild.length; i++){
                    
                    this.$refs.slotCardChild[i].setIsBooked(this.dayDate);
                }
           }
        },

        doSearch(){

            let saveSearchResultsMethod = this.saveSearchResults; 
        
            //console.log(`variables are: ${this.searchInput} and ${JSON.stringify(this.categorizedSlots)}`) 
        
            this.$search(this.searchInput, this.categorizedSlots, { keys: ['class.business.name', 'class.name',
            'instructor.name', 'slot.class.categories.category.name'], findAllMatches: true,  threshold: 0.1,
            }).then(results => {
            
               //console.log(`slots results are: ${JSON.stringify(results)}`);
                
                saveSearchResultsMethod(results);
            });
        },

        saveSearchResults(results){

            this.categorizedSlots = results.filter(item=>item);

            // this.setLocations();
            //
            this.SearchResults = results;
        },

        filterSlotsWithSearchResults(results){

            this.categorizedSlots = results;

            // this.setLocations();
        },

        format(value, event) {
            
            return moment(value).format('yyyyy-MM-dd')
        }
    },

    apollo: {

        second_slot: {

            query: myQueries.slot_mixed_only_query,

            variables: function(){

                return{

                    todayDate: this.fixedDayDate
                }
            },

            update(data){

            // console.log(`apollo slots: ${JSON.stringify(data.slot)}`)

               

            //     this.sendSlotPostMessage(data.slot);

            // alert(`second_slot; navigator.userAgent: ${navigator.userAgent}`);

            if(navigator.userAgent == 'Safari/602.1 ios-pnadi'){

            //   console.log(`apollo second_slots: ${JSON.stringify(data.slot)}`)
                
                this.second_slot = data.slot;

                this.slot = this.second_slot;

                this.setSlots()

                // this.sendSlotPostMessage(data.slot);
            }else{

                 this.second_slot = data.slot;

                this.slot = this.second_slot;

                this.setSlots()
            }

            // this.slot = data.slot;

            return data.slot;
            },


            error(error){
                
                // console.log(`in query`);
                componentsHelpers.sendError(this.$apollo, 0,'SecondSlots', 'apollo', 'slot query', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                this.slotError = JSON.stringify(error);
            },

            // skip(){

            //   return navigator.userAgent != 'Safari/602.1 ios-pnadi';
            // }
        },
        $subscribe:{

            second_bookings:{

                query: mySubscriptions.fake_bookings_subscriptions,   

                variables: function(){

                    // alert(`new data`);
                    return {

                        // userId:  this.token[0].user.id
                    }
                },

                result({data}) {

                    // console.log(`Subscribe Result new subscriptions Bookings results: ${JSON.stringify(data.fake_bookings)}`);

                    if(navigator.userAgent == 'Safari/602.1 ios-pnadi'){
                        
                        // console.log(`apollo second_bookings: ${JSON.stringify(data.fake_bookings)}`)

                        this.second_bookings = data.fake_bookings;
                        
                        this.sendBookingsPostMessage(data.fake_bookings);
                    }
                    
                    if(this.bookings.length < 1){

                        console.log(`in refetch`);
                        this.second_bookings = data.fake_bookings;

                        this.pastBookings = [];

                        this.comingBookings = [];

                        this.filteredBookings = this.bookings.filter(item=>item);

                        // this.filterBookings();

                        // this.allLoaded = true;
                    }

                    // this.allLoaded = true;
                },

                error(error){

                    // this.allLoaded = true;

                    componentsHelpers.sendError(this.$apollo, this.userId,'SecondSlots', 'apollo', 'subscribe bookings', error);

                    componentsHelpers.toastIt(this.$toasted, 'An error happened, and sent to admin', 3, 'outline', true);
                },

                // skip(){

                // return navigator.userAgent != 'Safari/602.1 ios-pnadi';
                // }
            },
        }
    },

    data: function(){

        return{

            userId: 0,
            onlyOnline: true,
            slot:[],
            second_slot:[],
            bookings: [],
            second_bookings: [],
            dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            fixedDayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
            categorizedSlots:[],
            timedCategorizedSlots:[],
            weekDayCategorizedSlots:[],
            startTimeAfter: '',
            startTimeBefore: '',
            savedStartTimeAfter: '',
            savedStartTimeBefore: '',
            
            searchInput: '',
            SearchResults: [],

            slotsCategoriesOptions: [],
            slotsCategoriesOptionsProxy: [],
            // classificationsSelectedResources: [],
            // classificationsShowLoadingSpinner: false,
            btnLabel: values => this.slotsCategoriesOptionsProxy.length > 0 ? `${this.$t('classes.selected')} ${this.slotsCategoriesOptionsProxy.length}` : this.$t('brand.categories'),
            position: this.$i18n.locale == 'ar'? 'bottom-left' :  'bottom-right',
            options: {
                
                multi: true,

                cssSelected: option => (option.selected ? { 'background-color': '#5764c6' } : ''),
            },
            timeBeforeColor: '',
            timeAfterColor: '',
            cardsViews:[],
            tokenError: '',
            userInfoError:'',
            instructorInfoError: '',
            brandInfoError:'',
            categoryError:'',
            slotError: '',
            bookingsError: '',
            createNew: false,
            allLoaded: false,
            daysCount:1,
            sevenDaysSlots: []
        }
    }
}
</script>

<style>

</style>